module.exports = __webpack_public_path__ + "img/_b-dagger_.26e547aa.svg";